import { css } from 'emotion';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import checked from '../assets/onSelectedColor/checked.svg';

import { BREAKPOINT_SMALL } from '../consts/breakpoints';

// #region Style
const itemWrapper = (isSelected: boolean) => css`
  position: relative;
  box-sizing: border-box;
  height: 60px;
  max-width: 60px;
  display: table-cell;
  vertical-align: middle;
  cursor: pointer;
  @media (min-width: ${BREAKPOINT_SMALL}) {
    height: 65px;
  }

  ${isSelected &&
    css`
      padding: 5px;
    `}
`;

const itemImage = css`
  width: 100%;
  height: auto;
  max-height: 50px;
`;

const checkIcon = css`
  position: absolute;
  right: 5px;
  top: 5px;
`;
// #endregion

interface IGroupOptionItemProps {
  item: string;
  isSelected?: boolean;
  onClick?(value?: string): void;
}

export const GroupOptionItem = observer(({ item, isSelected = false, onClick }: IGroupOptionItemProps) => {
  function onClickHanlder() {
    const imageName = item.split('-')[2];
    if (onClick) {
      onClick(imageName);
    }
  }

  return (
    <div className={itemWrapper(isSelected)} onClick={onClickHanlder} role="tab">
      {isSelected && <img className={checkIcon} src={checked} role="presentation" alt="" />}
      <img className={itemImage} src={item} role="presentation" alt="" />
    </div>
  );
});
